import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { QueryBuilderConfigProvider } from '@common/filter/query-builder-config-provider';
import { AdminDiaryEventFilterFieldProvider } from '@diary/filter/admin-diary-event-filter-field-provider';
import { addFilterFieldsToAdminForm, getDefaultWidgetConfigAdminForm } from '@feature/widget-admin/services/widget-admin-form';
import { WidgetConfiguration, WidgetConfigurationsService } from '@feature/widget-configs';
import { WidgetAdminHandler } from '@widget-admin/services/widget-admin-handler';
import { FormDefinition  } from '@feature/_app_modules/dynamic-forms/dynamic-form';
import { mapWherePropertiesMatch } from '@common/index';

@Injectable({
  providedIn: 'root'
})
export class RelatedContactsAdminHandler implements WidgetAdminHandler {

  constructor(
    private readonly widgetConfigService: WidgetConfigurationsService
  ) { }

  initialise(): boolean {
    return true;
  }

  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition {

    let formDefinition = getDefaultWidgetConfigAdminForm(selectedConfig);

    const fieldProvider = new AdminDiaryEventFilterFieldProvider();
    const configProvider = new QueryBuilderConfigProvider(fieldProvider);
    const queryConfig = configProvider.getQueryBuilderConfig();

    formDefinition = addFilterFieldsToAdminForm(selectedConfig, queryConfig, formDefinition);

    return formDefinition;
  }

  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    return this.widgetConfigService.createcopy(copyOfSelectedConfig).pipe(
      map(r => true)
    );
  }

  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {

    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    return this.widgetConfigService.save(copyOfSelectedConfig).pipe(
      map(r => true)
    );
  }

  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);

    return this.widgetConfigService.delete(copyOfSelectedConfig).pipe(
      map(r => true)
    );
  }
}
